import * as Yup from "yup";

export const ConfirmPaymentValidation = Yup.object({
  accountType: Yup.object().required("This field is required"),
  amountPaid: Yup.string().required("Required"),
  date: Yup.string().required("Required").nullable(),
  mainFileId: Yup.string().required("Required"),
});
